<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="card">
                    <personal-info></personal-info>
                    <hr>
                    <change-password></change-password>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PersonalInfo from './PersonalInfo';
    import ChangePassword from './ChangePassword';
    export default {
        components: {
            PersonalInfo,
            ChangePassword
        },
    }
</script>